import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/shared/models/api-response.interface';
import { HttpService } from './http.service';
import { VehicleCreationData } from 'src/app/shared/models/vehicle.model';
import { API_VERSIONS } from 'src/app/shared/consts/api-versions.const';
import { VehicleClass } from 'src/app/shared/models/contract.interface';

@Injectable({
  providedIn: 'root',
})
export class VehicleApiService {
  constructor(private apiService: HttpService) {}

  getAll(params = {}): Observable<ApiResponse> {
    return this.apiService.getReq(`/${API_VERSIONS.VEHICLES}/vehicles`, params);
  }

  getAllPaginated(params = {}): Observable<ApiResponse> {
    return this.apiService.getReq(`/${API_VERSIONS.VEHICLES}/vehicles/paging`, {
      params,
    });
  }

  getById(id: number): Observable<ApiResponse> {
    return this.apiService.getReq(`/vehicles/${id}`);
  }

  // getVehicleByVIN(vin: number): Observable<ApiResponse> {
  //   return this.apiService.getReq(`/vehicles/get-by-vin/${vin}`);
  // }

  getTypes(params = {}): Observable<ApiResponse> {
    return this.apiService.getReq('/types', {
      params: {
        model: 'vehicle',
        filter_by_active: 1,
        ...params,
      },
    });
  }

  getClasses(params = {}): Observable<ApiResponse> {
    return this.apiService.getReq('/vehicles/class', {
      params: {
        filter_by_active: 1,
        ...params,
      },
    });
  }

  getVehicleClassPaging(params = {}): Observable<ApiResponse<VehicleClass[]>> {
    return this.apiService.getReq(`/vehicles/class/paging`, {
      model: 'vehicle',
      ...params,
    });
  }

  getBrands(params = {}): Observable<ApiResponse> {
    return this.apiService.getReq('/vehicles/brand', { params });
  }

  getAllBrands(params = {}): Observable<ApiResponse> {
    return this.apiService.getReq('/vehicles/brand', {
      params: {
        filter_by_active: 1,
        ...params,
      },
    });
  }

  getBrandsByType(typeId: number, params = {}): Observable<ApiResponse> {
    return this.apiService.getReq('/vehicles/brand', {
      params: {
        filter_by_type: typeId,
        filter_by_active: 1,
        ...params,
      },
    });
  }

  getAllModels(params = {}): Observable<ApiResponse> {
    return this.apiService.getReq('/vehicles/model', { params });
  }

  getModelsByBrand(brandId: number): Observable<ApiResponse> {
    return this.apiService.getReq('/vehicles/model', {
      params: { filter_by_brand: brandId },
    });
  }

  getModelYears(modelId: number): Observable<ApiResponse> {
    return this.apiService.getReq(`/vehicles/model/years/${modelId}`);
  }

  getModelTrim(modelId: number): Observable<ApiResponse> {
    return this.apiService.getReq('/vehicles/trim?', {
      params: { filter_by_model: modelId },
    });
  }

  getOwners(search: string): Observable<ApiResponse> {
    return this.apiService.getReq('/third-parties', {
      params: {
        filter_by_type: 1,
        global_search: search,
      },
    });
  }

  getByVIN(type_id: number, vin: string): Observable<ApiResponse> {
    return this.apiService.postReq('/vehicles/decode', { type_id, vin });
  }

  getVehicleByVIN(vin: string): Observable<ApiResponse> {
    return this.apiService.getReq(`/vehicles/get-by-vin/${vin}`);
  }

  create(vehicle: VehicleCreationData): Observable<ApiResponse> {
    return this.apiService.postReq('/vehicles', vehicle);
  }

  storeManualVehicle(vehicle: any): Observable<ApiResponse> {
    return this.apiService.postReq('/vehicles/store-manual', vehicle);
  }

  update(id: number, vehicle: VehicleCreationData): Observable<ApiResponse> {
    return this.apiService.putReq(`/vehicles/${id}`, vehicle);
  }

  getEngineTypes(params = {}): Observable<ApiResponse> {
    return this.apiService.getReq('/vehicles/engine-types', {
      params: {
        ...params,
      },
    });
  }
}
